import BattleLinkModal from './BattleLinkModal';

export default BattleLinkModal;
